import { environment } from "../../../../environments/environment";

/**
 * Obtiene la URL de un recurso a partir de la ruta proporcionada.
 *
 * Si la ruta está vacía, devuelve una cadena vacía.
 * Si la ruta es una URL absoluta, devuelve la misma URL.
 * En caso contrario, devuelve la URL base de recursos configurada en el entorno.
 *
 * @param path - Ruta o URL del recurso.
 * @returns URL del recurso o una cadena vacía si la ruta está vacía.
 */
export function getAssetsUrl(path: string): string {
    if (!path) {
        return '';
    }

    if (path.startsWith('http')) {
        return path;
    }

    return `${environment.url_assets}`;
}